// To work with a Consent Management Platform (Ethyca), the default consent states are set here.
// Consent is denied for visitors outside of the US or in select states, which will be shown on the CMP.
// Set default consent states: https://developers.google.com/tag-platform/security/guides/consent
export const formatToGoogleAnalytics = (
  tagId: string,
  ooEthycaAds: boolean,
  marketingConsent: boolean,
  analyticsConsent: boolean
) => {
  if (tagId === '') {
    return ''
  }

  if (ooEthycaAds) {
    let adsPermission = 'denied'
    let analyticsPermission = 'denied'

    if (marketingConsent) {
      adsPermission = 'granted'
    }

    if (analyticsConsent) {
      analyticsPermission = 'granted'
    }
    return formatToGoogleAnalyticsWithEthyca(
      tagId,
      adsPermission,
      analyticsPermission
    )
  }

  return `
  <!-- Google tag (gtag.js) -->
  <script async src="https://www.googletagmanager.com/gtag/js?id=${tagId}"></script>
  <script>
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${tagId}');
    
    gtag('consent', 'default', {
      wait_for_update: 500,
      ad_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
      analytics_storage: 'denied'
    });
  </script>
  `
}

// Consent defaults are declared once in the HTML shell (public.template.hbs / _document.tsx),
// so this tag only needs to load gtag.js and configure itself.
export const formatToGoogleAnalyticsSharedConsent = (tagId: string) => {
  if (tagId === '') {
    return ''
  }

  return `
  <!-- Google tag (gtag.js) -->
  <script async src="https://www.googletagmanager.com/gtag/js?id=${tagId}"></script>
  <script>
    gtag('config', '${tagId}');
  </script>
  `
}

// Meta's tracking pixel allows for tracking events to be sent after the user's consent is granted.
// This is why we set the consent to revoked on initial load.
export const formatToFacebook = (
  pixelId: string,
  ooEthycaAds: boolean,
  marketingConsent: boolean
) => {
  if (pixelId === '') {
    return ''
  }

  if (ooEthycaAds) {
    let marketingPermission = 'revoke'
    if (marketingConsent) {
      marketingPermission = 'grant'
    }
    return formatToFacebookWithEthyca(pixelId, marketingPermission)
  }

  return `
  <!-- Facebook Pixel Code -->
  <script type="text/javascript">
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('dataProcessingOptions', ['LDU']);
    fbq('init', '${pixelId}');
    fbq('track', 'PageView');
  </script>
  <noscript>
    <img height="1" width="1" style="display:none" 
         src="https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1"/>
  </noscript>
    <!-- End Facebook Pixel Code -->
  `
}

const formatToGoogleAnalyticsWithEthyca = (
  tagId: string,
  adsPermission: string,
  analyticsPermission: string
) => {
  return `
  <!-- Google tag (gtag.js) -->
  <script>
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('consent', 'default', {
      wait_for_update: 500,
      ad_storage: '${adsPermission}',
      ad_user_data: '${adsPermission}',
      ad_personalization: '${adsPermission}',
      analytics_storage: '${analyticsPermission}'
    });
  </script>
  <script async src="https://www.googletagmanager.com/gtag/js?id=${tagId}"></script>
  <script>
    gtag('js', new Date());
    gtag('config', '${tagId}');
  </script>
  `
}

const formatToFacebookWithEthyca = (
  pixelId: string,
  marketingPermission: string
) => {
  return `
  <!-- Facebook Pixel Code -->
  <script>
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('dataProcessingOptions', ['LDU']);
    fbq('consent', '${marketingPermission}');
    fbq('init', '${pixelId}');
    fbq('track', 'PageView');
  </script>
  <noscript>
    <img height="1" width="1" style="display:none" 
         src="https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1"/>
  </noscript>
    <!-- End Facebook Pixel Code -->
  `
}
